

























import { Component, Prop, Mixins } from 'vue-property-decorator';
import ConversationData from '@/ts/ConversationData';
import DeviceMethods from '@/mixins/DeviceMethods.vue';
import PersonData from '@/ts/PersonData';
import { Actions } from '@/ts/store/Constants';
import ParticipantIcon from '@/components/Media/ParticipantIcon.vue';

@Component({
    components: {
        ParticipantIcon,
    },
})
export default class Conversation extends Mixins(DeviceMethods) {
    @Prop() public conversationData!: ConversationData;
    @Prop() public isActive!: boolean;

    constructor() {
        super();
    }

    get isHidden(): boolean {
        return this.$store.getters['Abuse/isContentHidden']('conversation', this.conversationData.id);
    }

    get isBlocked(): boolean {
        return this.$store.getters['Abuse/isContentBlocked']('user', this.conversationData.authorId);
    }

    get classes(): object {
        return {
            'hococo-conversation__isActive': (!this.mobileLayout && this.isActive),
            'hococo-conversation__isEmphasized': this.conversationData.emphasized,
        };
    }

    get conversationHeader(): string {
        if (this.conversationData.isUnderComposition) {
            return 'New conversation';
        } 

        return this.conversationData.recipientNames;
    }

    get firstInitial() {
        if (!this.conversationData) {
            return '';
        }

        return this.conversationData.firstInitial;
    }

    get otherParticipants() {
        if (!this.conversationData) {
            return [];
        }

        const userId = this.$store.getters['User/getUserId'];

        return this.conversationData.participants.filter((participant: number) => {
            return (participant !== userId);
        });
    }

    get dataLoaded(): boolean {
        return (
            this.conversationData !== null
         && this.conversationData.participants !== null
         && this.conversationData.participants.constructor === Array
         && this.conversationData.participants.length > 0
         && this.conversationData.messages !== null
        );
    }

    public getUser(userId: number): PersonData {
        const user = this.$store.getters['User/getCacheUser'](userId);

        if (user.hasMiniature === false && user.fetchedMiniature === false) {
            this.$store.dispatch(Actions.FETCH_MINIATURE, user.id);
            user.fetchedMiniature = true;
        }

        return this.$store.getters['User/getCacheUser'](userId);
    }
}
